import { LineStatusRemoteDto } from '../../../../../generated/signalR/line-status-remote-dto';

export class LineStatusValuesUpdated {
   public static readonly type = '[LineStatus] Line Status values updated';

   constructor(public lineStates: LineStatusRemoteDto[]) {}
}
